import React from "react";
import { Link } from "react-router-dom";
import { Layout, Dropdown, Menu, Row, Col, Avatar } from "antd";
import { LogoutOutlined, SettingOutlined } from "@ant-design/icons";
import { geturl } from "../../common/api/SafeClient";
import { User } from "../../types/UserGroup";
import "./AppHeader.less";

interface AppHeaderProps {
    me: Partial<User>;
    disabled?: boolean;
}

const PREFIX = "AppHeader";

export const AppHeader: React.FC<AppHeaderProps> = ({ me, disabled = false }) => {
    const menu = (
        <Menu onClick={() => {}} mode="horizontal">
            <Menu.Item>Hi {me.firstName} 👋</Menu.Item>
            <Menu.Item icon={<SettingOutlined />}>
                <Link to="/preferences"> My preferences</Link>
            </Menu.Item>
            <Menu.Item icon={<LogoutOutlined />}>
                <a href={geturl("/api/logout")}>Log out</a>
            </Menu.Item>
        </Menu>
    );

    return (
        <Layout.Header className={`${PREFIX}`}>
            <Row>
                <Col flex={1}>
                    <Link to="/dashboard">
                        <img src="/infinity-loop-logo-horz-color-wt.svg" alt="logo" />
                    </Link>
                </Col>
                <Col style={{ display: "inline-flex" }}>
                    <Dropdown overlay={menu}>
                        <Avatar
                            className={`${PREFIX}-avatar`}
                            shape="square"
                            size={64}
                            src={me.avatar || "/base-avatar.png"}
                        ></Avatar>
                    </Dropdown>
                </Col>
            </Row>
        </Layout.Header>
    );
};
